import style from './P2PContactCardListPage.css';
import { useEffect, useRef, useState } from 'preact/hooks';
import ContactsService from '../../services/contacts.service';
import NavigationUtils from '../../utils/navigation.utils';
import CardStatus from '../../constants/card.status';
import AppBar from '../../components/shared/AppBar/AppBar';
import P2PContactCardListPageSkeleton from '../../components/PeerToPeer/P2PContactCardLIstSkeleton/P2PContactCardListPageSkeleton';
import P2PContactCardListPageView from '../../components/PeerToPeer/P2PContactCardListPageView/P2PContactCardListPageView';
import FeatureFlags from '../../utils/feature-flags.utils';
import {EnterAmountType} from "../EnterAmountPage/EnterAmountProvider";

export default function P2PContactCardListPage({ cardUid, contactUserId }) {
  const backRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [cards, setCards] = useState([]);

  useEffect(() => {
    ContactsService.getCards(contactUserId)
      .then(({ data }) => {
        let activeCards = (data || []).filter(
          card => card.status === CardStatus.ACTIVE,
        );

        if (FeatureFlags.isP2PRestrictedToSameOrganization()) {
          activeCards = activeCards.filter(
            card =>
              card.organizationCode === NavigationUtils.getOrganizationCode(),
          );
        }

        if (activeCards.length === 1) {
          const currentParams = new URLSearchParams(window.location.search);
          const previousScreenParam =
            currentParams.get('previousScreen') || null;
          return NavigationUtils.navigate(
            NavigationUtils.Routes.ENTER_AMOUNT,
            true,
            {
              previousScreen: previousScreenParam,
              cardUidFrom: cardUid,
              cardUidTo: activeCards[0].uid,
              type: EnterAmountType.P2P,
            },
          );
        }

        setCards(activeCards);
        setIsLoading(false);
      })
      .catch(e => {
        console.error(`something went wrong`, e);
        return NavigationUtils.navigate(NavigationUtils.Routes.TRY_AGAIN);
      });
  }, [contactUserId]);

  return (
    <>
      <AppBar
        onBackClick={() => {
          NavigationUtils.back();
        }}
        backRef={backRef}
        className="fixed-bar"
      />
      <div className={style.container}>
        {isLoading ? (
          <P2PContactCardListPageSkeleton className={style.skeleton} />
        ) : (
          <P2PContactCardListPageView
            className={style.content}
            cards={cards}
            cardUid={cardUid}
          />
        )}
      </div>
    </>
  );
}
